import * as types from './mutation-types.js'
import { DELETE_TABLE_PERIMETER } from '@/store/modules/table/mutation-types'
import { DELETE_TABLE_FROM_PERIMETER, DELETE_PERIMETER } from '@/store/modules/perimeter/mutation-types'

export const loadRestaurantPermimeters = ({ commit, dispatch, state }, restaurant_id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`get/restaurant/${restaurant_id}/perimeters`).then((response) => {
            commit(types.LOAD_PERIMETERS, response.data.data)
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}

export const loadRoomPerimeters = ({ commit, dispatch, state }, room_id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`get/room/${room_id}/perimeters`).then((response) => {
            commit(types.LOAD_PERIMETERS, response.data.data)
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}

export const storePerimeter = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('/store/perimeter', data).then((response) => {
            commit(types.ADD_PERIMETER, response.data.data)
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}

export const setTableToPerimeter = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`set/tables/${data.perimeter_id}/to/perimeter`, data).then((response) => {
            commit(types.ADD_TABLES_TO_PERIMETER, {
                perimeter_id: data.perimeter_id,
                tables: response.data.tables
            })
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}

export const unsetTableToPerimeter = ({ commit, dispatch, state }, { perimeter_id, id }) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`unset/tables/${id}/to/perimeter`).then((response) => {
            commit('table/' + DELETE_TABLE_PERIMETER, id, {root: true})
            commit('perimeter/' + DELETE_TABLE_FROM_PERIMETER, { perimeter_id, table_id: id }, {root: true})
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}

export const deletePerimeter = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.delete(`delete/perimeters`, {
            params: data
        }).then((response) => {
            commit('perimeter/' + DELETE_PERIMETER, data['ids'], {root: true})
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}

export const setUsersToPerimeter = ({commit, dispatch, state}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('set/perimeters/to/users', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const unsetUsersToPerimeter = ({commit, dispatch, state}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('unset/perimeters/to/users', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}